import { colors } from './tokens';

export type Tone = 'default' | 'info' | 'warning' | 'success' | 'danger';

export const getToneBackground = (tone: string): string => {
  switch (tone) {
    case 'info':
      return colors.backgroundTones.info;
    case 'warning':
      return colors.backgroundTones.warning;
    case 'success':
      return colors.backgroundTones.success;
    case 'danger':
      return colors.backgroundTones.danger;
    default:
      return colors.backgroundTones.neutral;
  }
};

export const getToneForeground = (tone: string): string => {
  switch (tone) {
    case 'info':
      return colors.status.info;
    case 'warning':
      return colors.status.warning;
    case 'success':
      return colors.status.success;
    case 'danger':
      return colors.status.danger;
    default:
      return colors.text.tertiary;
  }
};
